import React, { useEffect } from 'react'
import Footer from '../../components/Footer'
import BangGiaFlyCam from '../../components/BangGiaFlycam'
import ScrollToTop from "../../components/ScrollToTop";
import BangGiaFlycamBanner from '../../components/Banner/BangGiaChupBanner';
export default function BangGia() {
    useEffect(() => {
        document.title = 'MinMin Wedding - Phóng Sự Cưới | Bảng giá';
    }, []);
    return (
        <>
            <ScrollToTop />
            <BangGiaFlycamBanner />
            <div>
                <BangGiaFlyCam />

            </div>
            <div>
                <Footer />
            </div>
        </>
    )
}